/* Wandry newsletter fixed discounts; one 3,000 JPY discount per order. */
(function () {
  'use strict';
  // Premium offers supersede the newsletter coupon. Keep legacy article routes unchanged.
  if (/^\/(?:products\/wandry|pages\/wandry-premium-top|pages\/wandry-premium-lp|pages\/advertorial-01|cart|a\/subscriptions(?:\/[^?]*)?)?\/?$/.test(window.location.pathname)) return;
  if (window.WD_COUPON) return;
  var key = 'wandry-newsletter-offer-v1', cartKey = 'ec-coupon-cart-wandry';
  var codes = ['WANDRY3000'];
  var retiredCodes = ['WANDRY15', 'WANDRY1000', 'WANDRY2000', 'WANDRY4000'];
  function isEligible() { try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {} return !!(eligible || (window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current())); }
  function offerAmount() { return window.EC_OFFER_AMOUNT ? EC_OFFER_AMOUNT() : 3000; }
  function owns(code) { return codes.concat(retiredCodes).concat(['W-SUMMER-057BCB58']).indexOf(String(code).toUpperCase()) >= 0; }
  var eligible = false;
  try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {}
  var pending;
  var applied = false;
  var verifiedItems = false;
  function markApplied(value, hasItems) { applied = value; verifiedItems = !!hasItems; document.dispatchEvent(new CustomEvent("wandry:newsletter-eligible")); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Keep every existing code, including identity-restricted codes awaiting checkout email.
  function mergeCodes(cart, selected, removeOwn) {
    var result = [], seen = {};
    (cart.discount_codes || []).map(function(entry) { return String(entry.code || ''); }).concat(selected ? [selected] : []).forEach(function(value) {
      var normalized = value.toUpperCase();
      if (!value || (removeOwn(value) && normalized !== String(selected || '').toUpperCase()) || seen[normalized]) return;
      seen[normalized] = true; result.push(value);
    });
    return result.join(',');
  }
  async function readCart() {
    var response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw Error('Cart could not be loaded');
    return response.json();
  }
  function allocationAmount(cart, selected) {
    var total = 0, found = false, wanted = String(selected).toUpperCase();
    function matches(application) { return application && String(application.code || application.title || '').toUpperCase() === wanted; }
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        if (matches(allocation.discount_application) && Number.isFinite(Number(allocation.amount))) { total += Number(allocation.amount); found = true; }
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function(entry) {
      var application = entry.discount_application || entry;
      var amount = entry.amount != null ? entry.amount : application.total_allocated_amount;
      if (matches(application) && amount != null && Number.isFinite(Number(amount))) { total += Number(amount); found = true; }
    });
    return found ? total : null;
  }
  function inspectOffer(cart, selected, productId) {
    var target = (cart.items || []).filter(function(item) { return Number(item.product_id) === productId; });
    var units = target.reduce(function(n,item) { return n + (Number(item.quantity) || 0); },0);
    var active = (cart.discount_codes || []).filter(function(entry) { return entry.applicable; });
    var usable = active.some(function(entry) { return String(entry.code).toUpperCase() === String(selected).toUpperCase(); });
    var expected = offerAmount() * 100 * units;
    var actual = allocationAmount(cart, selected);
    if (actual === null && usable && active.length === 1 && Number(cart.total_discount) === expected) actual = expected;
    var mismatch = units && usable && actual !== null && actual !== expected;
    active.forEach(function(entry) {
      if (!/^W[RF]3-[a-f0-9]{20}$/i.test(String(entry.code))) return;
      var value = allocationAmount(cart, entry.code);
      // Shopify can cap a fixed discount at the remaining subtotal.
      if (value !== null && value !== Math.min(300000, Number(cart.total_price) + value)) mismatch = true;
    });
    if (mismatch) {
      try { if (window.EC_MEASURE) window.EC_MEASURE.event('coupon_mismatch'); } catch (_) {}
      throw Error('Offer amount mismatch');
    }
    // An absent/inapplicable code can require checkout identity. It is not verified,
    // but it must not prevent the buyer from entering their email at checkout.
    return !!(units && usable && actual === expected);
  }
  function sectionRequest() {
    var names = [];
    ['cart-drawer', 'cart-items'].forEach(function(selector) {
      var element = document.querySelector(selector);
      if (element && element.getSectionsToRender) element.getSectionsToRender().forEach(function(section) {
        var name = section.section || section.id;
        if (names.indexOf(name) < 0) names.push(name);
      });
    });
    return names.slice(0, 5);
  }
  function renderCart(cart) {
    if (!cart.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents && cart.sections['cart-drawer']) {
      drawer.renderContents(cart, true);
      // Section HTML changes do not update the enclosing custom element.
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }
    var items = document.querySelector('cart-items');
    if (items && items.getSectionsToRender) items.getSectionsToRender().forEach(function(section) {
      var html = cart.sections[section.section || section.id], wrapper = document.getElementById(section.id);
      if (!html || !wrapper) return;
      var target = wrapper.querySelector(section.selector) || wrapper;
      target.innerHTML = items.getSectionInnerHTML(html, section.selector);
    });
  }
  async function apply(options) {
    options = options || {};
    var giftCart = options.cart || (window.WD_GIFTS && typeof WD_GIFTS.ensure === 'function' ? await WD_GIFTS.ensure() : null);
    if (!isEligible()) return giftCart;
    var special = window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current();
    codes[0] = special ? special.code : 'WANDRY3000';
    if (pending) return pending;
    pending = (async function () {
      var current = giftCart || await readCart();
      var discount = mergeCodes(current, codes[0], owns);
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discount, sections: options.render === false ? [] : sectionRequest(), sections_url: location.pathname })
      });
      if (!response.ok) throw Error('Offer could not be applied');
      var updated = await response.json();
      var verified = inspectOffer(updated, codes[0], 8791641129095);
      if (verified) { try { localStorage.setItem(cartKey, JSON.stringify({ token: String(updated.token || '').split('?')[0], at: Date.now() })); } catch (_) {} }
      markApplied(verified, verified);
      if (options.render !== false) renderCart(updated);
      return updated;
    })();
    try { return await pending; } catch (error) { markApplied(false); throw error; } finally { pending = null; }
  }
  async function checkout() {
    var cart = await apply();
    if (cart && !cart.item_count) { var error = Error('Cart is empty'); error.wandryGift = true; throw error; }
    return cart;
  }
  function checkoutError(error, target) {
    if (error.wandryGift && window.WD_GIFTS) WD_GIFTS.showError(target); else showError(target);
  }
  function forget() { eligible = false; try { localStorage.removeItem(key); localStorage.removeItem(cartKey); } catch (_) {} markApplied(false); }
  function remember() {
    eligible = true; applied = false; verifiedItems = false;
    try { localStorage.setItem(key, 'yes'); } catch (_) {}
    document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible'));
  }
  window.WD_COUPON = { amount: offerAmount, apply: apply, checkout: checkout, checkoutError: checkoutError, remember: remember, forget: forget, showError: showError, isEligible: isEligible, isApplied: function() { return applied; }, hasVerifiedItems: function() { return verifiedItems; } };
  function showError(form) {
    var target = form || document.querySelector('cart-drawer');
    if (!target) return;
    var message = target.querySelector('.wd-offer-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'wd-offer-error'; message.setAttribute('role', 'alert');
      target.appendChild(message);
    }
    message.textContent = '登録特典を適用できませんでした。再試行するか、この特典を外して購入手続きへ進めます。';
    if (target.querySelector('.wd-offer-skip')) return;
    var skip = document.createElement('button');
    skip.type = 'button'; skip.className = 'button wd-offer-skip';
    skip.textContent = 'この特典を使わず購入手続きへ';
    target.appendChild(skip);
    skip.addEventListener('click', async function () {
      skip.disabled = true;
      try {
        if (window.WD_GIFTS && typeof WD_GIFTS.ensure === 'function') { var giftCart = await WD_GIFTS.ensure(); if (!giftCart.item_count) throw Error('Cart is empty'); }
        var response = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!response.ok) throw Error('Cart could not be loaded');
        var cart = await response.json();
        var keep = (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(function (code) { return !owns(code); });
        response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
        if (!response.ok) throw Error('Offer could not be removed');
        var removed = await response.json();
        if ((removed.discount_codes || []).some(function(entry) { return entry.applicable && owns(entry.code); })) throw Error('Offer remains applied');
        eligible = false; if (window.EC_SPECIAL_OFFER) EC_SPECIAL_OFFER.clear(); markApplied(false);
        try { localStorage.removeItem(key); } catch (_) {}
        document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible'));
        try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} window.location.href = root + 'checkout';
      } catch (_) { skip.disabled = false; message.textContent = '購入手続きを読み込めませんでした。もう一度お試しください。'; }
    });
  }
  // Cover both the cart page and drawer checkout forms. The PDP awaits apply itself.
  document.addEventListener('submit', function (event) {
    var form = event.target, button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    button.disabled = true;
    checkout().then(function () {
      // Applying the discount re-renders cart sections and replaces this form.
      // The verified cart is ready; navigate without submitting a detached form.
      try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} window.location.href = root + 'checkout';
    }).catch(function (error) { button.disabled = false; checkoutError(error, form); });
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || new URL(link.href).origin !== location.origin || new URL(link.href).pathname !== '/checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    checkout().then(function () { window.location.href = link.href; }).catch(function (error) { checkoutError(error); });
  }, true);
  // Verify the email offer immediately; checkout repeats the verification.
  if (window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current()) {
    var initOffer = function () { apply().catch(function () {}); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffer, {once:true}); else initOffer();
  }
  // No background polling.
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) { applied = false; verifiedItems = false; document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible')); }
  });
})();

/* WANDRY CART PREVIEW */
/* Cart display is rendered by cart-drawer.liquid. */
